
import { useEffect, useState } from "react";

export function StatusBar() {
  const [isScrolled, setIsScrolled] = useState(false);

  // Detect iOS (both Safari browser AND PWA) - never render StatusBar on iOS
  // iOS Safari handles its own status bar styling, our synthetic bar causes visual issues
  const isIOS = typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (isIOS) {
    return null;
  }

  useEffect(() => {
    // Listen for scroll events
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isScrolled ? (
    <div className="fixed top-0 left-0 right-0 z-[110] bg-[#0f172a]/80 backdrop-blur-2xl transition-colors duration-300" />
  ) : null;
}
